import { useMap } from "@vis.gl/react-google-maps";
import { useMapDrawing } from "../hooks/useMapDrawing";

// Drop-in replacement for google.maps.drawing.DrawingManager, which was removed
// from the Maps JavaScript API as of v3.65. Keeps the same props/callback shape.
export const DrawingManager = ({ onPolygonComplete, Type = "POLYGON" }) => {
  const map = useMap();

  useMapDrawing({
    map,
    type: Type,
    polygonOptions: {
      fillColor: "#1890ff",
      fillOpacity: 0.3,
      strokeColor: "#096dd9",
      strokeWeight: 2,
    },
    polylineOptions: {
      strokeColor: "#096dd9",
      strokeWeight: 2,
    },
    onComplete: ({ coordinates }) => {
      onPolygonComplete({ shape: null, coordinates });
    },
  });

  return null;
};
